var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnooze(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 6.25c9.803 0 17.75 7.947 17.75 17.75S33.803 41.75 24 41.75 6.25 33.803 6.25 24 14.197 6.25 24 6.25zm0 3.5C16.13 9.75 9.75 16.13 9.75 24S16.13 38.25 24 38.25 38.25 31.87 38.25 24 31.87 9.75 24 9.75zm8.516 20.293a1.75 1.75 0 11-2.365 2.58l-8-7.333a1.75 1.75 0 01-.568-1.29v-7.333a1.75 1.75 0 013.5 0v6.563l7.433 6.813z",
    id: "snooze_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "snooze_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#snooze_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#snooze_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#snooze_svg__b)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTI0IDYuMjVjOS44MDMgMCAxNy43NSA3Ljk0NyAxNy43NSAxNy43NVMzMy44MDMgNDEuNzUgMjQgNDEuNzUgNi4yNSAzMy44MDMgNi4yNSAyNCAxNC4xOTcgNi4yNSAyNCA2LjI1em0wIDMuNUMxNi4xMyA5Ljc1IDkuNzUgMTYuMTMgOS43NSAyNFMxNi4xMyAzOC4yNSAyNCAzOC4yNSAzOC4yNSAzMS44NyAzOC4yNSAyNCAzMS44NyA5Ljc1IDI0IDkuNzV6bTguNTE2IDIwLjI5M2ExLjc1IDEuNzUgMCAxIDEtMi4zNjUgMi41OGwtOC03LjMzM2ExLjc1IDEuNzUgMCAwIDEtLjU2OC0xLjI5di03LjMzM2ExLjc1IDEuNzUgMCAwIDEgMy41IDB2Ni41NjNsNy40MzMgNi44MTN6IiBpZD0iYSIvPjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjx1c2UgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHhsaW5rOmhyZWY9IiNhIi8+PGcgbWFzaz0idXJsKCNiKSIgZmlsbD0iY3VycmVudENvbG9yIj48cGF0aCBkPSJNMCAwaDQ4djQ4SDB6Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgSnooze as ReactComponent };